
export const initialValues = {
  stateName: "",
  countryId: "",
  activeStatus: 1,
}